// extracted by mini-css-extract-plugin
module.exports = {"container":"Art_container__2WjEd","frame":"Art_frame__12ptX","caption":"Art_caption__Xcwqv","title":"Art_title__1ZN3W","info":"Art_info__BmgoG"};